<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <p-floatlabel variant="on">
            <input id="name" type="text" pInputText formControlName="name" />
            <label for="name">Name</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <textarea id="description" rows="5" cols="30" pInputTextarea formControlName="description"></textarea>
            <label for="description">Description</label>
        </p-floatlabel>
    </app-ibase-cru-modal-content>
</form>
